import { SVGAttributes } from "react";

export default (props: SVGAttributes<any>) => {
  return (
    <>
      <svg {...props} width="144" height="155" viewBox="0 0 144 155" fill="none" xmlns="http://www.w3.org/2000/svg">
        <rect
          x="6"
          y="68.082"
          width="57.5297"
          height="39.1202"
          rx="4"
          transform="rotate(-90 6 68.082)"
          fill="url(#paint0_linear_3561_23608)"
        />
        <rect
          width="17.9826"
          height="1.393"
          rx="0.696498"
          transform="matrix(0.999999 -0.00157214 0.00236805 0.999997 16.6943 41.3652)"
          fill="#B9D4FF"
        />
        <rect
          width="17.9826"
          height="1.393"
          rx="0.696498"
          transform="matrix(0.999999 -0.00157214 0.00236805 0.999997 16.6943 50.4922)"
          fill="#B9D4FF"
        />
        <rect
          width="17.9826"
          height="1.393"
          rx="0.696498"
          transform="matrix(0.999999 -0.00157214 0.00236805 0.999997 16.6943 55.0557)"
          fill="#B9D4FF"
        />
        <rect
          width="17.9826"
          height="1.393"
          rx="0.696498"
          transform="matrix(0.999999 -0.00157214 0.00236805 0.999997 16.6943 59.459)"
          fill="#0E2187"
          fillOpacity="0.72"
        />
        <rect
          width="17.5214"
          height="4.31302"
          rx="1"
          transform="matrix(0.999998 -0.00205038 0.00181571 0.999998 16.6836 19.6289)"
          fill="#B9D4FF"
        />
        <rect
          width="17.9826"
          height="1.393"
          rx="0.696498"
          transform="matrix(0.999999 -0.00154293 0.00241288 0.999997 16.6943 36.8301)"
          fill="#B9D4FF"
        />
        <rect
          width="6.00124"
          height="3.05941"
          rx="1"
          transform="matrix(0.999999 -0.00115694 0.00321789 0.999995 23.0137 26.6006)"
          fill="#B9D4FF"
        />
        <rect
          width="17.9826"
          height="1.393"
          rx="0.696498"
          transform="matrix(0.999999 -0.00154293 0.00241288 0.999997 16.6943 45.9287)"
          fill="#B9D4FF"
        />
        <rect
          x="98.5088"
          y="68.082"
          width="57.5297"
          height="39.1202"
          rx="4"
          transform="rotate(-90 98.5088 68.082)"
          fill="url(#paint1_linear_3561_23608)"
        />
        <rect
          width="17.9826"
          height="1.393"
          rx="0.696498"
          transform="matrix(0.999999 -0.00157214 0.00236805 0.999997 109.203 41.3652)"
          fill="#B9D4FF"
        />
        <rect
          width="17.9826"
          height="1.393"
          rx="0.696498"
          transform="matrix(0.999999 -0.00157214 0.00236805 0.999997 109.203 50.4922)"
          fill="#B9D4FF"
        />
        <rect
          width="17.9826"
          height="1.393"
          rx="0.696498"
          transform="matrix(0.999999 -0.00157214 0.00236805 0.999997 109.203 55.0557)"
          fill="#B9D4FF"
        />
        <rect
          width="17.9826"
          height="1.393"
          rx="0.696498"
          transform="matrix(0.999999 -0.00157214 0.00236805 0.999997 109.203 59.459)"
          fill="#B9D4FF"
        />
        <rect
          width="17.5214"
          height="4.31302"
          rx="1"
          transform="matrix(0.999998 -0.00205038 0.00181571 0.999998 109.192 19.6289)"
          fill="#B9D4FF"
        />
        <rect
          width="17.9826"
          height="1.393"
          rx="0.696498"
          transform="matrix(0.999999 -0.00154293 0.00241288 0.999997 109.203 36.8301)"
          fill="#B9D4FF"
        />
        <rect
          width="6.00124"
          height="3.05941"
          rx="1"
          transform="matrix(0.999999 -0.00115694 0.00321789 0.999995 115.522 26.6006)"
          fill="#B9D4FF"
        />
        <rect
          width="17.9826"
          height="1.393"
          rx="0.696498"
          transform="matrix(0.999999 -0.00154293 0.00241288 0.999997 109.203 45.9287)"
          fill="#B9D4FF"
        />
        <rect
          x="48.6162"
          y="74.9971"
          width="74.3189"
          height="46.2544"
          rx="4"
          transform="rotate(-90 48.6162 74.9971)"
          fill="url(#paint2_linear_3561_23608)"
        />
        <rect
          width="21.2821"
          height="1.64859"
          rx="0.824295"
          transform="matrix(0.999999 -0.00157214 0.00236805 0.999997 61.0889 37.2812)"
          fill="#B9D4FF"
        />
        <rect
          width="21.2821"
          height="1.64859"
          rx="0.824295"
          transform="matrix(0.999999 -0.00157214 0.00236805 0.999997 61.0889 48.083)"
          fill="#B9D4FF"
        />
        <rect
          width="21.2821"
          height="1.64859"
          rx="0.824295"
          transform="matrix(0.999999 -0.00157214 0.00236805 0.999997 61.0889 53.4844)"
          fill="#B9D4FF"
        />
        <rect
          width="21.2821"
          height="1.64859"
          rx="0.824295"
          transform="matrix(0.999999 -0.00157214 0.00236805 0.999997 61.0889 58.6953)"
          fill="#B9D4FF"
        />
        <rect
          width="27.6151"
          height="5.1044"
          rx="1"
          transform="matrix(0.999998 -0.00205038 0.00181571 0.999998 57.9707 11.5635)"
          fill="#B9D4FF"
        />
        <rect
          width="21.2821"
          height="1.64859"
          rx="0.824296"
          transform="matrix(0.999999 -0.00154293 0.00241288 0.999997 61.0889 31.9141)"
          fill="#B9D4FF"
        />
        <rect
          width="7.10238"
          height="3.62077"
          rx="1"
          transform="matrix(0.999999 -0.00115694 0.00321789 0.999995 68.3652 19.8076)"
          fill="#B9D4FF"
        />
        <rect
          width="21.2821"
          height="1.64859"
          rx="0.824296"
          transform="matrix(0.999999 -0.00154293 0.00241288 0.999997 61.0889 42.6816)"
          fill="#B9D4FF"
        />
        <circle
          cx="71.5544"
          cy="74.6189"
          r="7.79166"
          transform="rotate(11.8286 71.5544 74.6189)"
          fill="url(#paint3_linear_3561_23608)"
        />
        <path
          d="M69.3007 73.9294C68.8765 73.5757 68.2459 73.6327 67.8922 74.0569C67.5385 74.481 67.5955 75.1116 68.0197 75.4653L69.3007 73.9294ZM71.1257 76.7537L70.4852 77.5217C70.6989 77.6999 70.9771 77.781 71.2531 77.7456C71.529 77.7102 71.7777 77.5614 71.9394 77.335L71.1257 76.7537ZM75.2269 72.7326C75.5479 72.2832 75.4438 71.6586 74.9944 71.3376C74.545 71.0166 73.9204 71.1207 73.5994 71.5701L75.2269 72.7326ZM68.0197 75.4653L70.4852 77.5217L71.7662 75.9858L69.3007 73.9294L68.0197 75.4653ZM71.9394 77.335L75.2269 72.7326L73.5994 71.5701L70.312 76.1725L71.9394 77.335Z"
          fill="#C7D7FF"
        />
        <path
          opacity="0.8"
          d="M57.3369 131C57.3369 128.791 55.5461 127 53.3369 127H32.3369C30.1278 127 28.3369 128.791 28.3369 131V155H57.3369V131Z"
          fill="url(#paint4_linear_3561_23608)"
        />
        <path
          opacity="0.8"
          d="M114.337 116C114.337 113.791 112.546 112 110.337 112H90.3369C88.1278 112 86.3369 113.791 86.3369 116V155H114.337V116Z"
          fill="url(#paint5_linear_3561_23608)"
        />
        <path
          opacity="0.8"
          d="M28.7002 138.626C28.7002 136.417 26.9093 134.626 24.7002 134.626H4.00019C1.79105 134.626 0.00019455 136.417 0.00019455 138.626V154.822H28.7002V138.626Z"
          fill="url(#paint6_linear_3561_23608)"
        />
        <path
          opacity="0.8"
          d="M86.3369 123C86.3369 120.791 84.5461 119 82.3369 119H61.3369C59.1278 119 57.3369 120.791 57.3369 123V155H86.3369V123Z"
          fill="url(#paint7_linear_3561_23608)"
        />
        <path
          opacity="0.8"
          d="M143.337 108C143.337 105.791 141.546 104 139.337 104H118.337C116.128 104 114.337 105.791 114.337 108V155H143.337V108Z"
          fill="url(#paint8_linear_3561_23608)"
        />
        <path
          d="M44.2791 117.15C42.2646 116.58 40.2207 115.365 40.1237 114.79L33.8287 114.492L33.1894 119.478C33.1847 119.599 34.0631 119.983 35.4919 120.038C37.2779 120.108 38.5457 119.706 41.2073 120.26C43.8688 120.814 47.7289 120.44 47.918 120.176C48.107 119.913 48.7019 118.404 44.2791 117.15Z"
          fill="#214C97"
        />
        <path
          d="M42.1215 120.406C44.2947 120.82 46.7793 120.466 47.7794 120.269C48.1056 120.113 48.0324 119.708 48.0351 119.546C46.8466 119.74 44.2118 120.089 42.8573 119.935C41.1643 119.742 40.931 119.253 37.5328 119.513C34.8144 119.721 33.5534 119.17 33.2628 118.869L33.1684 119.594C33.9641 120.255 34.7735 120.189 36.7926 120.227C38.8118 120.264 39.3035 119.869 42.1215 120.406Z"
          fill="#163873"
        />
        <path
          d="M41.1197 115.954C42.2149 116.734 43.7814 117.24 44.6126 117.333C42.1843 117.38 39.6622 115.993 39.3904 114.902L40.0359 114.933C40.1346 115.126 40.3714 115.422 41.1197 115.954Z"
          fill="#163873"
        />
        <path
          d="M21.0397 131.958C19.007 131.453 17.5531 129.731 17.4389 129.166L10.9328 128.946L10.1705 133.205C10.1695 133.324 11.817 134.269 13.2482 134.282C15.0372 134.298 15.3278 134.783 18.3202 135.04C21.0313 135.272 24.5896 135.105 24.7709 134.84C24.9522 134.574 25.5023 133.066 21.0397 131.958Z"
          fill="#214C97"
        />
        <path
          d="M18.0152 135.112C20.2046 135.478 23.1779 135.168 24.6365 135.021C24.9808 134.908 24.9105 134.33 24.9105 134.33C23.703 134.37 20.4496 134.683 18.7811 134.504C17.0807 134.321 16.3903 134.039 14.0658 133.92C11.3333 133.781 10.5034 132.939 10.2519 132.605L10.054 133.575C10.8921 134.215 11.662 134.156 13.6675 134.449C15.673 134.742 14.9643 134.602 18.0152 135.112Z"
          fill="#163873"
        />
        <path
          d="M18.1843 130.562C19.1043 131.559 20.5546 132.41 21.3628 132.696C18.9314 132.16 16.7226 130.25 16.6923 129.156L17.3292 129.339C17.3849 129.545 17.5558 129.88 18.1843 130.562Z"
          fill="#163873"
        />
        <path
          d="M26.0483 45.6124L33.6938 49.5848L32.79 46.7004L33.4537 42.2973C33.4537 42.2973 36.0653 41.6552 36.3663 40.5976C37.4476 36.7986 37.7979 30.1907 37.7979 30.1907C34.7721 28.2853 30.9551 28.1698 27.8175 29.8842L27.3522 30.1379L26.0451 45.6091L26.0483 45.6124Z"
          fill="#FFBE9D"
        />
        <path
          d="M33.4465 42.2577C33.4465 42.2577 31.6736 42.1334 29.9768 41.1628C29.9768 41.1628 30.5195 42.6044 33.342 42.744L33.4497 42.2577L33.4465 42.2577Z"
          fill="#EB996E"
        />
        <path
          d="M27.2447 33.1401C27.2006 33.1043 25.4122 32.087 25.164 34.432C24.9159 36.7732 26.8995 36.5765 26.9103 36.5106C26.9212 36.4446 27.2446 33.144 27.2446 33.144L27.2447 33.1401Z"
          fill="#FFBE9D"
        />
        <path
          d="M39.4448 28.637C39.5279 28.293 39.4584 27.9013 39.2071 27.6535C38.9558 27.4057 38.5155 27.3495 38.2458 27.5749C38.4492 27.1276 38.1533 26.527 37.6722 26.4221C37.2199 26.3209 36.7764 26.607 36.3149 26.6561C35.8661 26.7053 35.4184 26.5307 35.0292 26.2995C34.6401 26.0683 34.2904 25.7771 33.8947 25.5554C33.0683 25.0985 32.0598 24.9806 31.153 25.2358C30.2431 25.4909 29.4478 26.1193 28.9816 26.9393C28.3984 26.6501 27.6525 26.8539 27.193 27.3125C26.7335 27.7711 26.5292 28.4392 26.5044 29.0883C26.4867 29.5263 26.5458 29.9625 26.6273 30.396C26.6203 30.431 26.6132 30.4661 26.6061 30.5044C26.392 32.049 26.2843 33.8867 26.9379 34.0012C28.0826 34.1984 28.1458 31.9951 28.1458 31.9951C29.636 31.6708 29.443 29.4819 29.8446 29.2174C30.2461 28.9529 31.099 28.3256 33.8069 30.2923C34.8579 31.0572 36.3828 31.2775 37.2411 31.2198C37.2666 31.2203 37.2922 31.2207 37.3179 31.2148C37.3243 31.2149 37.3307 31.215 37.3339 31.2151C37.3435 31.2153 37.35 31.209 37.3596 31.2092C37.6352 31.1823 37.905 31.1201 38.1662 31.0066C38.4596 30.8808 38.7383 30.6876 38.8969 30.4122C39.0555 30.1368 39.0721 29.7595 38.8753 29.5095C39.1356 29.2712 39.3554 28.9745 39.4417 28.6305L39.4448 28.637Z"
          fill="url(#paint9_linear_3561_23608)"
        />
        <path
          d="M13.7988 77.6658L25.2902 77.2165L26.286 78.3707L28.8694 78.2522C29.1307 78.3083 45.1148 91.2235 45.0849 93.869C45.0551 96.5144 41.6464 116.056 41.6464 116.056L33.3747 115.751L35.3602 97.5442L35.1524 96.5037L27.1826 91.0864C26.9464 97.2731 26.6709 103.856 26.4791 104.543C26.1124 105.858 18.7789 129.493 18.7789 129.493L10.1276 129.181L16.833 103.283L14.6298 83.3956L13.7987 77.669L13.7988 77.6658Z"
          fill="url(#paint10_linear_3561_23608)"
        />
        <path
          d="M33.5619 48.2463C33.5619 48.2463 26.4431 44.5501 26.1113 43.8113L23.1664 45.1357C20.8673 46.3057 18.6629 51.0002 18.1172 53.5209L12.8986 77.6C12.8986 77.6 22.7167 80.9719 30.5055 78.7166C30.5055 78.7166 33.6184 67.9822 34.6667 60.4347C35.7149 52.8872 33.5618 48.2495 33.5618 48.2495L33.5619 48.2463Z"
          fill="url(#paint11_linear_3561_23608)"
        />
        <path
          d="M20.6501 56.1146L27.7948 57.8947L25.6313 66.4746L35.2881 70.8958C35.2881 70.8958 37.7889 70.0623 38.3057 70.1358C38.3982 70.1503 38.5892 70.2019 38.8404 70.2801C39.3267 70.2731 40.6837 70.2343 40.9716 70.0572C41.0946 69.9827 41.2593 69.893 41.417 69.8415C41.6969 69.7539 41.9474 70.0465 41.8337 70.3164C41.7467 70.5195 41.5636 70.9097 41.2084 71.0887C41.4785 71.1865 41.7231 71.2742 41.9233 71.3451C42.3141 71.4867 42.5525 71.9135 42.4141 72.3045C42.4041 72.3299 42.3941 72.3521 42.3841 72.3743C42.1626 72.7605 41.7284 72.7141 41.7284 72.7141C41.7284 72.7141 42.2053 73.0461 42.0186 73.6249C41.832 74.2038 41.092 74.0909 41.092 74.0909C41.092 74.0909 41.1231 74.1363 41.1633 74.2138C41.4161 74.724 40.9989 75.3146 40.4339 75.2529L40.0955 75.2179C40.0955 75.2179 40.4606 75.5382 40.3222 75.9324C40.0523 76.6889 38.2979 76.2532 38.2979 76.2532C38.2979 76.2532 33.8532 75.4893 33.7712 75.427L30.244 74.5499C26.943 73.729 23.7447 72.5394 20.7097 71.0033C19.8791 70.583 19.3898 69.6977 19.4757 68.7707L20.6502 56.1082L20.6501 56.1146Z"
          fill="#FFBE9D"
        />
        <path
          d="M39.7807 70.6368C39.7671 70.6781 40.2303 70.8851 40.8281 71.0785C41.4227 71.2687 41.9095 71.4089 41.9263 71.3645C41.9399 71.3231 41.4767 71.1162 40.8789 70.9227C40.2843 70.7325 39.7975 70.5923 39.7807 70.6368Z"
          fill="#EB996E"
        />
        <path
          d="M39.8651 72.1298C39.8484 72.1679 40.2378 72.3831 40.7595 72.5399C41.2811 72.6968 41.7251 72.7338 41.7322 72.6923C41.7395 72.6477 41.316 72.5406 40.8071 72.3872C40.295 72.2338 39.885 72.0886 39.865 72.133L39.8651 72.1298Z"
          fill="#EB996E"
        />
        <path
          d="M38.7242 71.5555C38.6824 71.5643 38.683 71.7083 38.7861 71.8382C38.8892 71.9681 39.0293 72.0027 39.0492 71.9647C39.0724 71.9235 38.9939 71.8421 38.9127 71.7382C38.8314 71.6375 38.766 71.5435 38.7242 71.5555Z"
          fill="#EB996E"
        />
        <path
          d="M39.1001 73.5293C39.0897 73.5707 39.5375 73.7453 40.0973 73.9157C40.6603 74.0861 41.1285 74.1908 41.1421 74.1494C41.1556 74.1081 40.7111 73.9335 40.1449 73.763C39.5787 73.5925 39.1104 73.4879 39.1001 73.5293Z"
          fill="#EB996E"
        />
        <path
          d="M37.9679 72.4462C37.9521 72.4331 37.8971 72.4704 37.857 72.5593C37.8139 72.6449 37.7888 72.7916 37.8404 72.9365C37.8921 73.0847 38.0023 73.1795 38.091 73.2227C38.1798 73.266 38.2439 73.2608 38.2475 73.2384C38.261 73.1971 38.0677 73.1007 37.9917 72.8849C37.9126 72.6691 38.0058 72.4725 37.9678 72.4494L37.9679 72.4462Z"
          fill="#EB996E"
        />
        <path
          d="M38.2492 74.8706C38.2388 74.9152 38.6555 75.0381 39.1749 75.1437C39.6943 75.2525 40.1252 75.3021 40.1355 75.2607C40.146 75.2161 39.7292 75.0964 39.2098 74.9876C38.6904 74.8788 38.2595 74.8292 38.2524 74.8706L38.2492 74.8706Z"
          fill="#EB996E"
        />
        <path
          d="M37.1904 73.6831C37.1714 73.6732 37.1258 73.7171 37.0986 73.8062C37.0681 73.8984 37.0688 74.0328 37.1174 74.1681C37.218 74.4355 37.385 74.5762 37.4173 74.5544C37.4594 74.5296 37.351 74.3388 37.2687 74.1165C37.1833 73.891 37.2284 73.703 37.1936 73.6832L37.1904 73.6831Z"
          fill="#EB996E"
        />
        <defs>
          <linearGradient
            id="paint0_linear_3561_23608"
            x1="34.7648"
            y1="68.082"
            x2="34.7648"
            y2="107.202"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#5580F5" />
            <stop offset="1" stopColor="#87BBFF" />
          </linearGradient>
          <linearGradient
            id="paint1_linear_3561_23608"
            x1="127.274"
            y1="68.082"
            x2="127.274"
            y2="107.202"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#5580F5" />
            <stop offset="1" stopColor="#87BBFF" />
          </linearGradient>
          <linearGradient
            id="paint2_linear_3561_23608"
            x1="85.7757"
            y1="74.9971"
            x2="85.7757"
            y2="121.251"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#5580F5" />
            <stop offset="1" stopColor="#87BBFF" />
          </linearGradient>
          <linearGradient
            id="paint3_linear_3561_23608"
            x1="65.3068"
            y1="67.8878"
            x2="79.5161"
            y2="77.287"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#5541C7" />
            <stop offset="1" stopColor="#0330A2" />
          </linearGradient>
          <linearGradient
            id="paint4_linear_3561_23608"
            x1="57.3369"
            y1="127"
            x2="25.5351"
            y2="127.671"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#286EFB" />
            <stop offset="1" stopColor="#5985F6" />
          </linearGradient>
          <linearGradient
            id="paint5_linear_3561_23608"
            x1="114.337"
            y1="112"
            x2="83.6234"
            y2="112.408"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#2355F8" />
            <stop offset="1" stopColor="#5B87F6" />
          </linearGradient>
          <linearGradient
            id="paint6_linear_3561_23608"
            x1="28.7002"
            y1="134.626"
            x2="-2.76028"
            y2="135.537"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#255FF9" />
            <stop offset="1" stopColor="#80B3FE" />
          </linearGradient>
          <linearGradient
            id="paint7_linear_3561_23608"
            x1="86.3369"
            y1="119"
            x2="54.5295"
            y2="119.522"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#286EFB" />
            <stop offset="1" stopColor="#5985F6" />
          </linearGradient>
          <linearGradient
            id="paint8_linear_3561_23608"
            x1="143.337"
            y1="104"
            x2="111.525"
            y2="104.369"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#2459F8" />
            <stop offset="1" stopColor="#79AAFC" />
          </linearGradient>
          <linearGradient
            id="paint9_linear_3561_23608"
            x1="33.0574"
            y1="25.1202"
            x2="32.8906"
            y2="34.1215"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#2B4E60" />
            <stop offset="1" stopColor="#0034BA" />
          </linearGradient>
          <linearGradient
            id="paint10_linear_3561_23608"
            x1="29.6031"
            y1="77.0686"
            x2="28.6167"
            y2="130.3"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#161E22" />
            <stop offset="1" stopColor="#232D33" />
          </linearGradient>
          <linearGradient
            id="paint11_linear_3561_23608"
            x1="24.3588"
            y1="43.7788"
            x2="23.6971"
            y2="79.4846"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#4050D1" />
            <stop offset="1" stopColor="#303AC4" />
          </linearGradient>
        </defs>
      </svg>
    </>
  );
};
